import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    DistrictMapping,
    DistrictsOptions,
    PaginatedResponse
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class DistrictMappingsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<DistrictMapping>> {
        return this.apiService.get<any>('/district-mappings', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    view(id: string): Observable<any> {
        return this.apiService.get<DistrictMapping>(`/district-mappings/${id}`);
    }

    edit(id: string, data: Record<string, any>): Observable<DistrictMapping> {
        return this.apiService.patch<DistrictMapping>(`/district-mappings/${id}`, data)
            .pipe(map(response => response.data));
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/district-mappings/export', params);
    }

    options(context: Record<string, any> = {}): Observable<DistrictsOptions> {
        return this.apiService.get<DistrictsOptions>(
            '/district-mappings/options',
            this.apiService.build(context)
        ).pipe(
            map(res => res.data ?? res)
        );
    }

    autocomplete(
        field: 'district_name' | 'mapped_district.district' | 'states' | 'counties',
        query: string,
        context: Record<string, any> = {}
    ) {
        return this.apiService.get<string[]>(
            `/district-mappings/autocomplete/${encodeURIComponent(field)}`,
            this.apiService.build({ q: query, ...context })
        ).pipe(
            map((res: any) => {
                const raw = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
                return raw.filter((item: unknown): item is string => typeof item === 'string' && item.trim() !== '');
            })
        );
    }
}
